export default "__VITE_PUBLIC_ASSET__a8b37f69__"